import { NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';
import { StorageService } from './_services/storage.service';
import { TranslateService } from '@ngx-translate/core';
import { HtmlToTextPipe } from './_pipe/htmlToText.pipe';

export class CustomNgbDatepickerI18n implements NgbDatepickerI18n {

  constructor(private storage: StorageService, private translate: TranslateService) {}

  getWeekdayShortName(weekday: number): string {
    if (this.storage.isBrowser) {
      const htmlPipe = new HtmlToTextPipe();
      const traduzioni = this.storage.get('superServizio_' + this.translate.currentLang) ? this.storage.get('superServizio_' + this.translate.currentLang).traduzioni : {};
      switch (weekday) {
        case 1: return htmlPipe.transform(traduzioni.GIORNI_SETTIMANA_LUN);
        case 2: return htmlPipe.transform(traduzioni.GIORNI_SETTIMANA_MAR);
        case 3: return htmlPipe.transform(traduzioni.GIORNI_SETTIMANA_MER);
        case 4: return htmlPipe.transform(traduzioni.GIORNI_SETTIMANA_GIO);
        case 5: return htmlPipe.transform(traduzioni.GIORNI_SETTIMANA_VEN);
        case 6: return htmlPipe.transform(traduzioni.GIORNI_SETTIMANA_SAB);
        case 7: return htmlPipe.transform(traduzioni.GIORNI_SETTIMANA_DOM);
        default: return '';
      }
    }
  }

  getMonthShortName(month: number, year?: number): string {
    return month.toString();
  }


  getMonthFullName(month: number, year?: number): string {
    if (this.storage.isBrowser) {
      const htmlPipe = new HtmlToTextPipe();
      const traduzioni = this.storage.get('superServizio_' + this.translate.currentLang) ? this.storage.get('superServizio_' + this.translate.currentLang).traduzioni : {};
      switch (month) {
        case 1: return htmlPipe.transform(traduzioni.GENNAIO);
        case 2: return htmlPipe.transform(traduzioni.FEBBRAIO);
        case 3: return htmlPipe.transform(traduzioni.MARZO);
        case 4: return htmlPipe.transform(traduzioni.APRILE);
        case 5: return htmlPipe.transform(traduzioni.MAGGIO);
        case 6: return htmlPipe.transform(traduzioni.GIUGNO);
        case 7: return htmlPipe.transform(traduzioni.LUGLIO);
        case 8: return htmlPipe.transform(traduzioni.AGOSTO);
        case 9: return htmlPipe.transform(traduzioni.SETTEMBRE);
        case 10: return htmlPipe.transform(traduzioni.OTTOBRE);
        case 11: return htmlPipe.transform(traduzioni.NOVEMBRE);
        case 12: return htmlPipe.transform(traduzioni.DICEMBRE);
        default: return '';
      }
    }
  }

  getDayAriaLabel(date: import('@ng-bootstrap/ng-bootstrap').NgbDateStruct): string {
    return 'AriaLabel';
  }

  getDayNumerals(date: import('@ng-bootstrap/ng-bootstrap').NgbDateStruct): string {
    return date.day.toString();
  }

  getWeekNumerals(weekNumber: number): string {
    return weekNumber.toString();
  }

  getYearNumerals(year: number): string {
    return year.toString();
  }
}
